import { useContext } from 'react'

import { AddActionDialog } from '@pages/EntityCreateOrEdit'
import { PageContext } from '@pages/TimeLineCreateOrEdit/TimeLineCreateOrEdit'

import { CATEGORIES, ENTITY_TYPES_REQUEST } from '@constants'
import { ActionRow } from '@types'

export const ObjectYAddActionDialog = () => {
  const { handlers, state } = useContext(PageContext)

  const { handleSaveTimeLine, handleCloseObjectYAddActionDialog, handleChangeObjectYAction } =
    handlers

  const {
    objectYAddActionDialogData,
    objectYShowAddActionDialog,
    watchId,
    isCreateOrUpdateLoading,
  } = state

  const handleCreateAction = (data: ActionRow) => {
    handleChangeObjectYAction(data)

    return handleSaveTimeLine()
  }

  const handleEditAction = (data: ActionRow) => {
    handleChangeObjectYAction(data)

    return handleSaveTimeLine()
  }

  if (!objectYAddActionDialogData) {
    return null
  }

  return (
    <AddActionDialog
      actionEventsCategoryCode={CATEGORIES.BINDING_TIME_TABLE_OBJECT_Y_EVENTS_ACTION}
      actionTable={objectYAddActionDialogData.actionTable}
      bindingValuesAction={objectYAddActionDialogData.bindingValuesAction}
      columns={[]}
      createAction={handleCreateAction}
      currentRow={objectYAddActionDialogData.currentRow}
      editAction={handleEditAction}
      isActionLoading={isCreateOrUpdateLoading}
      modalType={objectYAddActionDialogData.modalType}
      objectCode={objectYAddActionDialogData.objectCode}
      showDialog={objectYShowAddActionDialog}
      tooltipEventsCategoryCode={CATEGORIES.BINDING_TIME_TABLE_OBJECT_Y_EVENTS_ACTION_TOOLTIP}
      type={ENTITY_TYPES_REQUEST.TIME_TABLE}
      variablesConfig={{
        entityType: ENTITY_TYPES_REQUEST.TIME_TABLE,
        entityId: watchId,
      }}
      onCloseModal={handleCloseObjectYAddActionDialog}
    />
  )
}
